<script>

    import Common from "../public/lib/common";
    import Rest from "../public/lib/rest";

    import moment from 'moment-timezone'
    import debounce from 'lodash/debounce'

    let futureRents = [];
    let pastRents = [];
    let actualRents = [];

    let futureRentsToBePaid = 0;
    let pastRentsToBePaid = 0;
    let actualRentsToBePaid = 0;

    let filterClient;
    let filterInvoice;
    let filterPaid;
    let filterCar;

    let cars = [];
    let selectedClientIndex = -1;
    let clientPhrase = "";
    let extensionMode = false;

    let newPayment = {};

    let newRent = {
        invoice: false
    };
    let foundClients = [];


    let invoiceModalDTO = {};

    function filter() {

        filterSingleList(futureRents);
        futureRentsToBePaid = calculateSumToBePaid(futureRents);
        futureRents = futureRents;

        filterSingleList(pastRents);
        pastRentsToBePaid = calculateSumToBePaid(pastRents);
        pastRents = pastRents;

        filterSingleList(actualRents);
        actualRentsToBePaid = calculateSumToBePaid(actualRents);
        actualRents = actualRents;


        setTimeout(function () {
            jQuery('[data-toggle="tooltip"]').tooltip();
        }, 500);
    }


    function calculateSumToBePaid(arr) {
        if (!arr || !arr.length) {
            return 0;
        }
        let tmpArr = arr.map(o => {
            if (o.id > 240 && o.show) {
                return parseInt(o.price) - parseInt(o.paid)
            } else {
                return 0;
            }
        }).filter(o => {
            return o > 0;
        })
        if (!tmpArr || !tmpArr.length) {
            return 0;
        }

        return tmpArr.reduce(function (previousValue, currentValue, index, array) {
            return previousValue + currentValue;
        });
    }

    function filterSingleList(filtered) {
        filtered.forEach(rent => {
            rent.show = true;
            if (filterClient && filterClient.length) {

                let total = "";
                if (rent.client.name1) {
                    total = total + rent.client.name1;
                }
                if (rent.client.name2) {
                    total = total + rent.client.name2;
                }
                if (total.toLowerCase().indexOf(filterClient.toLowerCase()) < 0) {
                    rent.show = false;
                }
            }

            if (rent.show && filterInvoice && filterInvoice !== "ALL") {
                if (filterInvoice === "YES") {
                    rent.show = (rent.invoice === true);
                } else {
                    rent.show = (rent.invoice === false);
                }
            }

            if (rent.show && filterPaid && filterPaid !== "ALL") {
                if (filterPaid === "YES") {
                    rent.show = (rent.paid >= (rent.price)) && rent.id > 240;
                } else {
                    rent.show = (rent.paid < (rent.price)) && rent.id > 240;
                }
            }

            if (rent.show && filterCar && filterCar !== "ALL") {
                rent.show = (rent.car.uuid == filterCar)
            }

        });
    }

    function getPayment(rent) {
        newPayment = {
            type: 'CASH',
            rentId: rent.id
        };
        let w = jQuery('#newPaymentModal').modal();
    }

    function showNewClientModalForExtension(rent) {
        extensionMode = true;
        newRent = {
            invoice: false,
            carUuid: rent.car.uuid,
            clientUuid: rent.client.uuid,
            startDate: rent.endDateLong
        };
        let w = jQuery('#newRentModal').modal();
        jQuery('#startDate').flatpickr({
            enableTime: true,
            dateFormat: "d-m-Y H:i",
            time_24hr: true,
            locale: "pl"
        });
        jQuery('#endDate').flatpickr({
            enableTime: true,
            dateFormat: "d-m-Y H:i",
            time_24hr: true,
            locale: "pl"
        });
    }

    function showNewRentModal() {
        extensionMode = false;
        newRent = {
            invoice: false,
            carUuid: cars[0].uuid
        };
        let w = jQuery('#newRentModal').modal();
        jQuery('#startDate').flatpickr({
            enableTime: true,
            dateFormat: "d-m-Y H:i",
            time_24hr: true,
            locale: "pl"
        });
        jQuery('#endDate').flatpickr({
            enableTime: true,
            dateFormat: "d-m-Y H:i",
            time_24hr: true,
            locale: "pl"
        });
    }

    function printGasSummary(r) {
        Rest.printGasSummary(r.id);
    }

    function printRent(r) {
        Rest.printRent(r.id);
    }

    function printInvoice(r) {
        invoiceModalDTO = {
            clientNip: r.client.defaultNip,
            clientName: r.client.defaultInvoiceName,
            clientPostalCode: r.client.defaultInvoicePostalCode,
            clientCity: r.client.defaultInvoiceCity,
            clientAddress: r.client.defaultInvoiceAddress,
            rent: r.invoice,
            title: "Wynajem auta dostawczego",
            e100Available: r.invoice,
            e100: false,
            rentObject: r,
            amount: 0
        }

        if (r.invoiceId) {
            downloadInvoice();
        } else {
            calcInvoiceAmount();
            jQuery('#invoiceModal').modal();
        }
    }

    function generateInvoice() {

        let copy = JSON.parse(JSON.stringify(invoiceModalDTO));

        copy.rentId = copy.rentObject.id;

        delete copy.e100Available;
        delete copy.rentObject;

        jQuery('#invoiceModal').modal('toggle');

        Rest.generateInvoice(copy).then(function (response) {
            downloadInvoice()
        }).catch(function (present) {
            Common.error(JSON.stringify(present));
        });
    }

    function downloadInvoice() {
        Rest.getInvoiceUuid(invoiceModalDTO.rentObject.id).then(function (response) {
            window.open(Common.BASE_API + "report/print/" + response.value, '_blank').focus();
        }).catch(function (present) {
            Common.error(JSON.stringify(present));
        });
    }

    function calcInvoiceAmount() {

        let amount = 0
        if (invoiceModalDTO.rent) {
            amount += invoiceModalDTO.rentObject.price;
        }
        invoiceModalDTO.amount = amount;
    }

    function sendSMSWithDocuments(r) {
        Rest.sendSMSWithDocuments(r.id).then(function (response) {
            Swal.fire({
                icon: 'success',
                title: 'OK',
                text: 'Wysłano'
            });
            reloadRents();
        });
    }

    function sendLinkToPayment(rent) {
        Rest.sendLinkToPayment({
            'amount': (rent.price) - rent.paid,
            'rentUuid': rent.uuid
        }).then(function (response) {
            Swal.fire({
                icon: 'success',
                title: 'OK',
                text: 'Wysłano'
            });
        });
    }

    function deleteRent(r) {
        Swal.fire({
            title: 'Na pewno ?',
            text: "Nie da się tego cofnąć",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie'
        }).then((result) => {
            if (result.value) {
                Rest.deleteRent(r.id).then(function (response) {
                    alert("Usunięto");
                    reloadRents();
                }).catch(function (present) {
                    alert("Wystąpił jakiś błąd");
                });
            }
        })
    }

    function editRent(rent) {
        extensionMode = false;
        newRent = JSON.parse(JSON.stringify(rent));
        newRent.carUuid = newRent.car.uuid;
        newRent.clientUuid = newRent.client.uuid;
        clientPhrase = newRent.client.name2;
        searchClient();

        delete newRent.car;
        delete newRent.client;
        delete newRent.paid;
        delete newRent.left;
        delete newRent.nettoPricePerDay;
        delete newRent.gasPrice;
        delete newRent.show;

        newRent.endDate = moment.unix(newRent.endDateLong / 1000).utc().format('DD-MM-YYYY HH:mm');
        newRent.startDate = moment.unix(newRent.startDateLong / 1000).utc().format('DD-MM-YYYY HH:mm');

        delete newRent.endDateLong;
        delete newRent.startDateLong;

        let w = jQuery('#newRentModal').modal();
        jQuery('#startDate').flatpickr({
            enableTime: true,
            dateFormat: "d-m-Y H:i",
            time_24hr: true,
            locale: "pl"
        });
        jQuery('#endDate').flatpickr({
            enableTime: true,
            dateFormat: "d-m-Y H:i",
            time_24hr: true,
            locale: "pl"
        });
    }

    function selectClientIndex(idx) {
        selectedClientIndex = idx;
        newRent.clientUuid = foundClients[idx].uuid;
    }

    function searchClient() {
        Common.searchClients(clientPhrase).then(function (response) {
            foundClients = response.filter(a => {
                return a.address && a.address.length && a.city && a.city.length
            });
            if (newRent.clientUuid) {
                selectedClientIndex = foundClients.indexOf((c) => {
                    return c.uuid === newRent.clientUuid;
                })
            }
        }).catch(function (present) {
            Common.error(JSON.stringify(present));
        });
    }

    function savePayment() {
        Rest.savePayment(newPayment).then(function (response) {
            alert("Zapisano");
            jQuery('#newPaymentModal').modal('toggle');
            reloadRents();
        }).catch(function (present) {
            present.json().then(body => {
                alert(body.description);
            });
        });
    }

    function save() {
        Rest.saveRent(newRent).then(function (response) {
            Swal.fire({
                icon: 'success',
                title: 'OK',
                text: 'Zapisano'
            });
            jQuery('#newRentModal').modal('toggle');
            reloadRents();
        }).catch(function (present) {
            present.json().then(body => {
                Swal.fire({
                    icon: 'error',
                    title: 'Błąd',
                    text: body.description
                });
            });
        });
    }

    function reloadRents() {

        Rest.getActualRents().then(function (response) {
            actualRents = response.value;
            let now = new Date().getTime();
            actualRents.forEach((rent) => {
                let leftHours = Math.round((parseInt(rent.endDateLong) - now) / (1000 * 60 * 60));
                if (leftHours < 24) {
                    rent.left = leftHours + ' godzin';
                } else if (leftHours < 48) {
                    rent.left = '1 dzień ' + (leftHours - 24) + ' godzin';
                } else {
                    let days = Math.floor(leftHours / 24);
                    rent.left = days + ' dni ' + (leftHours - (days * 24)) + ' godzin';
                }
            });
            filter();
        });
        Rest.getPastRents().then(function (response) {
            pastRents = response.value;
            filter();
        });
        Rest.getFutureRents().then(function (response) {
            futureRents = response.value;
            filter();
        });
    }

    export function setup(data) {
        moment.tz.setDefault("Europe/Warsaw");
        cars = data.cars.sort(function (a, b) {
            if (a.carType === b.carType) {
                return a.name.localeCompare(b.name);
            }
            return a.carType.localeCompare(b.carType);
        });
        reloadRents();
    }


    const handleSearchCarInput = debounce(e => {
        filterCar = e.target.value;
        filter();
    }, 300);

    const handleSearchPhraseInput = debounce(e => {
        filterClient = e.target.value;
        filter();
    }, 300);

    const handleSearchInvoiceInput = debounce(e => {
        filterInvoice = e.target.value;
        filter();
    }, 300);

    const handleSearchPaidInput = debounce(e => {
        filterPaid = e.target.value;
        filter();
    }, 300);
</script>

<div class="row">
    <div class="col-12 mt-4">
        <main class="chart-container menuButtonsContainer">
            <button type="button"
                    class="menuButton btn  btn-info maxWt200"
                    on:click="{showNewRentModal}">
                <span><i class="fas fa-plus"></i> Nowy wynajem</span>
            </button>
        </main>

        <main class="chart-container menuButtonsContainer">
            <table id="searchInputTable">
                <tr>
                    <td>
                        Auto
                    </td>
                    <td>
                        Klient
                    </td>
                    <td>
                        Faktura vat
                    </td>
                    <td>
                        Zapłacone
                    </td>
                </tr>
                <tr>
                    <td>
                        <select on:input={handleSearchCarInput}>
                            <option value="ALL">
                                Wszystkie
                            </option>
                            {#each cars as car}
                                <option value="{car.uuid}">
                                    [{car.carType}] - [{car.registrationNumber}] - {car.name}
                                </option>
                            {/each}
                        </select>
                    </td>
                    <td>
                        <input type="text" class="form-control maxwt200px"
                               placeholder="Klient" on:keyup="{handleSearchPhraseInput}">
                    </td>
                    <td>
                        <select on:input={handleSearchInvoiceInput}>
                            <option value="ALL">
                                Wszystkie
                            </option>
                            <option value="YES">
                                Z fakturą
                            </option>
                            <option value="NO">
                                Bez faktury
                            </option>
                        </select>
                    </td>
                    <td>
                        <select on:input={handleSearchPaidInput}>
                            <option value="ALL">
                                Wszystkie
                            </option>
                            <option value="YES">
                                Zapłacone
                            </option>
                            <option value="NO">
                                Nie zapłacone
                            </option>
                        </select>
                    </td>
                </tr>
            </table>
        </main>

        {#if futureRents.length > 0}
            <main class="chart-container mt-4 ">
                <div class="largeFontDiv">Przyszłe wynajmy <span
                        class="float-right mr-4">Do zapłaty: {futureRentsToBePaid}  PLN</span></div>
                <table class="table table-dark noMarginBottom smallFontOnMobile">
                    <thead>
                    <tr>
                        <th>Auto</th>
                        <th></th>
                        <th class="d-none d-sm-table-cell">Klient</th>
                        <th>Początek wynajmu</th>
                        <th>Koniec wynajmu</th>
                        <th>Kwota</th>
                        <th class="d-none d-sm-table-cell">Faktura</th>
                        <th>Netto / dzień</th>
                        <th class="d-none d-sm-table-cell">Do zapłaty</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each futureRents as rent, i}
                        {#if rent.show}
                            <tr>
                                <td>
                                    {rent.car.name} &nbsp; {rent.car.registrationNumber}
                                </td>
                                <td>
                                    {#if rent.info && rent.info.trim().length > 0}
                                        <div data-html="true" data-toggle="tooltip" data-placement="top"
                                             title="{rent.info}"><i class="fas fa-question yellowcolor"></i></div>
                                    {/if}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    <div data-html="true" data-toggle="tooltip" data-placement="top"
                                         title="{rent.client.phone}">
                                        {rent.client.name1} &nbsp; {rent.client.name2}
                                    </div>
                                </td>
                                <td>{rent.startDate}</td>
                                <td>{rent.endDate}</td>
                                <td>{rent.price}</td>
                                <td class="d-none d-sm-table-cell">
                                    {#if rent.invoice}
                                        <span>TAK</span>
                                    {:else}
                                        <span>NIE</span>
                                    {/if}
                                </td>
                                <td>{Math.round(rent.nettoPricePerDay)}</td>
                                <td class="d-none d-sm-table-cell"
                                    class:supergreen="{ rent.paid >= rent.price}"
                                    class:superred="{ rent.paid < rent.price}">
                                    {rent.price - rent.paid} PLN
                                </td>
                                <td>
                                    <button type="button"
                                            class:hidden="{rent.price <= rent.paid}"
                                            class="menuButton btn btn-sm  btn-primary maxWt200"
                                            on:click="{() => getPayment(rent)}">
                                        <span>Wpłata</span>
                                    </button>
                                    <button type="button"
                                            class="menuButton btn btn-sm btn-success maxWt200"
                                            on:click="{() => printRent(rent)}">
                                        <span>Umowa</span>
                                    </button>
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-warning maxWt200"
                                            on:click="{() => editRent(rent)}">
                                        <span>Edycja</span>
                                    </button>
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-danger maxWt200"
                                            on:click="{() => deleteRent(rent)}">
                                        <span>Usuń</span>
                                    </button>
                                </td>
                            </tr>
                        {/if}
                    {/each}
                    </tbody>
                </table>
            </main>
        {/if}

        {#if actualRents.length > 0}
            <main class="chart-container mt-4 ">
                <div class="largeFontDiv">Aktualne wynajmy <span
                        class="float-right mr-4">Do zapłaty: {actualRentsToBePaid}  PLN</span></div>
                <table class="table table-dark noMarginBottom smallFontOnMobile">
                    <thead>
                    <tr>
                        <th>Auto</th>
                        <th></th>
                        <th class="d-none d-sm-table-cell">Klient</th>
                        <th class="d-none d-sm-table-cell">Początek wynajmu</th>
                        <th class="d-none d-sm-table-cell">Koniec wynajmu</th>
                        <th class="d-none d-sm-table-cell">Faktura</th>
                        <th>Netto / dzień</th>
                        <th>Do końca</th>
                        <th>Kwota</th>
                        <th>Do zapłaty</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each actualRents as rent, i}
                        {#if rent.show}
                            <tr>
                                <td>{rent.car.name} &nbsp; {rent.car.registrationNumber}</td>
                                <td>
                                    {#if rent.info && rent.info.trim().length > 0}
                                        <div data-html="true" data-toggle="tooltip" data-placement="top"
                                             title="{rent.info}"><i class="fas fa-question yellowcolor"></i></div>
                                    {/if}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    <div data-html="true" data-toggle="tooltip" data-placement="top"
                                         title="{rent.client.phone}">
                                        {rent.client.name1} &nbsp; {rent.client.name2}
                                    </div>
                                </td>
                                <td class="d-none d-sm-table-cell">{rent.startDate}</td>
                                <td class="d-none d-sm-table-cell">{rent.endDate}</td>
                                <td class="d-none d-sm-table-cell">
                                    {#if rent.invoice}
                                        <span>TAK</span>
                                    {:else}
                                        <span>NIE</span>
                                    {/if}
                                </td>
                                <td>{Math.round(rent.nettoPricePerDay)}</td>
                                <td>{rent.left}</td>
                                <td>{rent.price}</td>
                                <td class:supergreen="{ rent.paid >= rent.price}"
                                    class:superred="{ rent.paid < rent.price}">
                                    {(rent.price - rent.paid).toFixed(2)} PLN
                                </td>
                                <td>
                                    <!-- AKCJE -->
                                    <!--                                    <button type="button"-->
                                    <!--                                            class="menuButton btn btn-sm  btn-info maxWt200"-->
                                    <!--                                            on:click="{() => showNewClientModalForExtension(rent)}">-->
                                    <!--                                        <span>Przedłuż</span>-->
                                    <!--                                    </button>-->
                                    <button type="button"
                                            class:hidden="{rent.price <= rent.paid}"
                                            class="menuButton btn btn-sm  btn-primary maxWt200"
                                            on:click="{() => getPayment(rent)}">
                                        <span>Wpłata</span>
                                    </button>
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-warning maxWt200"
                                            on:click="{() => editRent(rent)}">
                                        <span>Edycja</span>
                                    </button>
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-danger maxWt200"
                                            on:click="{() => deleteRent(rent)}">
                                        <span>Usuń</span>
                                    </button>

                                    <button type="button"
                                            class="menuButton btn btn-sm btn-success maxWt200"
                                            on:click="{() => printRent(rent)}">
                                        <span>Umowa</span>
                                    </button>
                                    {#if rent.paid >= rent.price}
                                        {#if rent.invoice}
                                            <button type="button"
                                                    class="menuButton btn btn-sm btn-primary maxWt200"
                                                    on:click="{() => printInvoice(rent)}">
                                                <span>Faktura</span>
                                            </button>
                                        {/if}
                                    {/if}
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-secondary maxWt200"
                                            class:btn-danger={!rent.documentsSent}
                                            class:btn-success={rent.documentsSent}
                                            on:click="{() => sendSMSWithDocuments(rent)}">
                                        <span>Wyślij dokumenty</span>
                                    </button>
                                </td>
                            </tr>
                        {/if}
                    {/each}
                    </tbody>
                </table>
            </main>
        {/if}


        {#if pastRents.length > 0}
            <main class="chart-container mt-4 ">
                <div class="largeFontDiv">Stare wynajmy <span class="float-right mr-4">Do zapłaty: {pastRentsToBePaid}
                    PLN</span></div>
                <table class="table table-dark noMarginBottom smallFontOnMobile">
                    <thead>
                    <tr>
                        <th>Auto</th>
                        <th></th>
                        <th>Klient</th>
                        <th>Początek wynajmu</th>
                        <th>Koniec wynajmu</th>
                        <th class="d-none d-sm-table-cell">Faktura</th>
                        <th class="d-none d-sm-table-cell">Netto / dzień</th>
                        <th>Kwota</th>
                        <th class="d-none d-sm-table-cell">Do zapłaty</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each pastRents as rent, i}
                        {#if rent.show}
                            <tr>
                                <td>{rent.car.name} &nbsp; {rent.car.registrationNumber}</td>
                                <td>
                                    {#if rent.info && rent.info.trim().length > 0}
                                        <div data-html="true" data-toggle="tooltip" data-placement="top"
                                             title="{rent.info}"><i class="fas fa-question yellowcolor"></i></div>
                                    {/if}
                                </td>
                                <td>
                                    <div data-html="true" data-toggle="tooltip" data-placement="top"
                                         title="{rent.client.phone}">
                                        {rent.client.name1} &nbsp; {rent.client.name2}
                                    </div>
                                </td>
                                <td>{rent.startDate}</td>
                                <td>{rent.endDate}</td>
                                <td class="d-none d-sm-table-cell">
                                    {#if rent.invoice}
                                        <span>TAK</span>
                                    {:else}
                                        <span>NIE</span>
                                    {/if}
                                </td>
                                <td class="d-none d-sm-table-cell">{Math.round(rent.nettoPricePerDay)}</td>
                                <td>{rent.price}</td>
                                <td class="d-none d-sm-table-cell"
                                    class:supergreen="{ rent.paid >= rent.price}"
                                    class:superred="{ rent.paid < rent.price}">
                                    {(rent.price - rent.paid).toFixed(2)} PLN
                                </td>
                                <td>
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-primary maxWt200"
                                            on:click="{() => getPayment(rent)}">
                                        <span>Wpłata</span>
                                    </button>
                                    <button type="button"
                                            class="menuButton btn btn-sm  btn-warning maxWt200"
                                            on:click="{() => editRent(rent)}">
                                        <span>Edycja</span>
                                    </button>

                                    {#if rent.paid >= rent.price}
                                        <button type="button"
                                                class="menuButton btn btn-sm btn-success maxWt200"
                                                on:click="{() => printRent(rent)}">
                                            <span>Umowa</span>
                                        </button>

                                        {#if rent.invoice}
                                            <button type="button"
                                                    class="menuButton btn btn-sm btn-primary maxWt200"
                                                    on:click="{() => printInvoice(rent)}">
                                                <span>Faktura</span>
                                            </button>
                                        {/if}
                                    {/if}
                                </td>
                            </tr>
                        {/if}
                    {/each}
                    </tbody>
                </table>
            </main>
        {/if}
    </div>
</div>

<div class="modal" role="dialog" id="newRentModal" style="z-index: 1050; color: black">
    <div class="modal-dialog largeModalDialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title largeFont">Nowy wynajem</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-12 col-lg-6">

                        <div class="form-group" class:hidden="{extensionMode}">
                            <label>Auto </label>
                            <select bind:value={newRent.carUuid}>
                                {#each cars as car}
                                    <option value={car.uuid}>
                                        [{car.carType}] - {car.name} - {car.registrationNumber}
                                    </option>
                                {/each}
                            </select>
                        </div>

                        <div class="form-group" class:hidden="{extensionMode}">
                            <label for="startDate">Początek </label>
                            <input type="text" class="form-control" id="startDate"
                                   placeholder="Początek"
                                   bind:value={newRent.startDate}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Koniec </label>
                            <input type="text" class="form-control" id="endDate"
                                   placeholder="Koniec"
                                   bind:value={newRent.endDate}>
                        </div>

                        <div class="form-group" class:hidden="{extensionMode}">
                            <label for="endDate">Klient </label>
                            <input type="text" class="form-control"
                                   placeholder="Klient" on:keyup="{searchClient}"
                                   bind:value={clientPhrase}>
                        </div>

                    </div>

                    <div class="col-12 col-lg-6"
                         class:hidden="{!extensionMode}">
                    </div>

                    <div class="col-12 col-lg-6">

                        <div class="form-group">
                            <label for="endDate">Kwota </label>
                            <input type="number" class="form-control"
                                   placeholder="Kwota"
                                   bind:value={newRent.price}>
                        </div>

                        <div class="form-group approveToggle">
                            <label for="formGroupExampleInput2">Faktura </label>
                            <label class="form-switch">
                                <input type="checkbox" bind:checked={newRent.invoice}>
                                <i></i>
                                {#if newRent.invoice === true}
                                    <span>Faktura VAT</span>
                                {/if}
                                {#if newRent.invoice === false}
                                    <span>Bez faktury</span>
                                {/if}
                            </label>
                        </div>

                        <div class="form-group">
                            <label>Info </label>
                            <textarea cols="50" rows="5" bind:value={newRent.info} class="w-full"></textarea>
                        </div>
                    </div>
                </div>

                {#if foundClients.length > 0}
                    <div class="row pointer">
                        <div class="col-12">
                            <table class="table table-striped table-condensed smallFontOnMobile">
                                <thead>
                                <tr>
                                    <th>Imię</th>
                                    <th>Nazwisko</th>
                                    <th>Pesel</th>
                                </tr>
                                </thead>
                                <tbody>
                                {#each foundClients as client, i}
                                    <tr on:click="{() => selectClientIndex(i)}"
                                        class:selectedRow="{selectedClientIndex === i}">
                                        <td>{client.name1}</td>
                                        <td>{client.name2}</td>
                                        <td>{client.pesel}</td>
                                    </tr>
                                {/each}
                                </tbody>
                            </table>
                        </div>
                    </div>
                {/if}

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-info" on:click={save}><i class="fas fa-save"></i>&nbsp;Zapisz
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal" tabindex="-1" role="dialog" id="newPaymentModal" style="z-index: 2000; color: black">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title largeFont">Nowa wpłata</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row">
                    <div class="col-12 col-lg-6">

                        <div class="form-group">
                            <label>Forma wpłaty </label>
                            <select bind:value={newPayment.type}>
                                <option value="CASH">
                                    Gotówka
                                </option>
                                <option value="TRANSFER">
                                    Wpłata na konto
                                </option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Kwota </label>
                            <input type="number" class="form-control"
                                   placeholder="Kwota"
                                   bind:value={newPayment.amount}>
                        </div>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-info" on:click={savePayment}><i class="fas fa-save"></i>&nbsp;Zapisz
                </button>
            </div>
        </div>
    </div>
</div>


<div class="modal" tabindex="-1" role="dialog" id="invoiceModal" style="z-index: 2000; color: black">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title largeFont">Drukowanie faktury</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">

                        <div class="form-group">
                            <label for="endDate">NIP </label>
                            <input type="text" class="form-control"
                                   placeholder="Nip"
                                   bind:value={invoiceModalDTO.clientNip}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Nazwa firmy na fakturze </label>
                            <input type="text" class="form-control"
                                   placeholder="Nazwa firmy na fakturze "
                                   bind:value={invoiceModalDTO.clientName}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Kod pocztowy na fakturze </label>
                            <input type="text" class="form-control"
                                   placeholder="Kod pocztowy na fakturze"
                                   bind:value={invoiceModalDTO.clientPostalCode}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Miasto na fakturze </label>
                            <input type="text" class="form-control"
                                   placeholder="Miasto na fakturze "
                                   bind:value={invoiceModalDTO.clientCity}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Adres na fakturze</label>
                            <input type="text" class="form-control"
                                   placeholder="Adres na fakturze"
                                   bind:value={invoiceModalDTO.clientAddress}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Tytuł na fakturze </label>
                            <input type="text" class="form-control"
                                   placeholder="Tytuł na fakturze"
                                   bind:value={invoiceModalDTO.title}>
                        </div>

                        <div class="form-group">
                            <label for="endDate">Kwota brutto na fakturze</label>
                            <b>{invoiceModalDTO.amount}</b>
                        </div>

                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-info" on:click={generateInvoice}><i class="fas fa-check"></i>&nbsp;Generuj
                </button>
            </div>
        </div>
    </div>
</div>

<style>
</style>
